import React, { memo, useEffect, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';

import { Col } from 'react-bootstrap';
import { replaceAll } from 'utils';

import * as _ from 'lodash';

import {
  analBasicInfoRequest,
  analStockRealRequest,
} from 'containers/market/actions';
import { AlgoSignalContext } from 'containers/socket/signalAlgo';
import {
  makeGetAnalBasicInfo,
  makeGetAnalStockReal,
  makeGetToken,
} from 'lib/selector';
import OverviewStock from './layout/overviewStock';

function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

function TabAnalysisStockOverview(props) {
  const as = React.useContext(AlgoSignalContext);
  const frameRef = useRef(null);
  const dispatch = useDispatch();

  const [symActive, setSymActive] = React.useState(null);
  const [indexToShow, setIndexToShow] = React.useState(null);

  const {
    symbol,
    theme,
    stockDetail,
    analBasicInfo,
    setChildSymActive,
    t,
    lang,
    algoSignal,
    algoStock,
    algoSChart,
    token,
  } = props;

  const preSymbol = usePrevious(symbol);
  const preAlgoSignal = usePrevious(algoSignal);
  const preSymActive = usePrevious(symActive);
  const preAlgoStock = usePrevious(algoStock);
  const preAnalStReal = usePrevious(stockDetail);

  useEffect(() => {
    window.addEventListener('message', handlerMessage);
    setSymActive(symbol);
    // setSymbolTradingview(symbol);

    setTimeout(() => {
      if (symbol && symbol !== 'VNINDEX') {
        sendMessage(symbol);
      }
    }, 1000);
    // clean up
    return () => {
      window.removeEventListener('message', handlerMessage);

      if (symActive) {
        var msg = {
          action: 'leave',
          channelName: 'stock-realtime:' + symActive,
        };
        as.sendMessage(msg);
        msg = {
          action: 'leave',
          channelName: 'stock-chart:' + symActive,
        };
        as.sendMessage(msg);
      }
    };
  }, []);

  React.useEffect(() => {
    if (
      algoStock &&
      !_.isEqual(algoStock, preAlgoStock) &&
      algoStock?.CompanyID === stockDetail?.CompanyID
    ) {
      setIndexToShow(algoStock);
    }
  }, [algoStock]);

  React.useEffect(() => {
    if (stockDetail && !_.isEqual(stockDetail, preAnalStReal)) {
      setIndexToShow(stockDetail);
    }
  }, [stockDetail]);

  useEffect(() => {
    if (symbol && symbol !== preSymbol) {
      // log(symbol, preSymbol);
      setSymActive(symbol);
    }
  }, [symbol]);

  React.useEffect(() => {
    console.log('algoSignal', algoSignal);
    if (algoSignal && !_.isEqual(algoSignal, preAlgoSignal) && symActive) {
      var msg = {
        action: 'reg',
        channelName: 'stock-realtime:' + symActive,
      };
      as.sendMessage(msg);
      msg = {
        action: 'reg',
        channelName: 'stock-chart:' + symActive,
      };
      as.sendMessage(msg);
    }
  }, [algoSignal]);

  useEffect(() => {
    if (symActive && symActive !== preSymActive) {
      var msg;
      if (preSymActive) {
        msg = {
          action: 'leave',
          channelName: 'stock-realtime:' + preSymActive,
        };
        as.sendMessage(msg);
        msg = {
          action: 'leave',
          channelName: 'stock-chart:' + preSymActive,
        };
        as.sendMessage(msg);
      }

      msg = {
        action: 'reg',
        channelName: 'stock-realtime:' + symActive,
      };
      as.sendMessage(msg);
      msg = {
        action: 'reg',
        channelName: 'stock-chart:' + symActive,
      };
      as.sendMessage(msg);

      sendMessage(symActive);

      if (symActive !== 'VNINDEX') {
        dispatch(analStockRealRequest(symActive));
        getBasicInfo();
      }
    }
  }, [symActive]);

  function getBasicInfo() {
    const _params = {
      lang,
      secList: symActive.toUpperCase(),
      Exchange: '',
    };
    dispatch(analBasicInfoRequest(_params));
  }

  // send message to frame chart
  const sendMessage = (sym) => {
    // log('send message to frame chart');
    if (frameRef && frameRef.current && frameRef.current.contentWindow) {
      const _data = { symbolChart: sym };
      frameRef.current.contentWindow.postMessage(JSON.stringify(_data), '*');
    }
  };

  function handlerMessage(event) {
    try {
      const data = event.data;
      // log('message from frame', data);
      if (data && data.startsWith('#CHANGESYM#')) {
        const _newSym = replaceAll(data, '#CHANGESYM#', '');
        // log(_newSym);
        setSymActive(_newSym);
        setChildSymActive(_newSym);
      }
    } catch (error) {
      // log(error)
    }
  }

  return (
    <div
      className="d-flex flex-row w-100 mt-2"
      style={{ height: 'calc(100vh - 185px)' }}
    >
      <Col
        className="p-3"
        style={{
          background: theme === 'dark' ? '#1C192C' : '#C4C4C4',
          borderRadius: '5px',
        }}
      >
        <iframe
          ref={frameRef}
          title="chart"
          src={
            `/chartTVS/?resolution=D&symbol=${
              symbol || 'APS'
            }&lang=${lang}&theme=${theme}` + (token ? `&u=${token?.user}` : '')
          }
          scrolling="no"
          style={{
            height: '100%',
            border: `2px solid ${theme === 'dark' ? '#202B33' : '#C4C4C4'}`,
          }}
        ></iframe>
      </Col>
      <div style={{ width: '315px' }} className="ml-2">
        <OverviewStock
          stockDetail={indexToShow}
          algoSChart={algoSChart}
          basicInfo={analBasicInfo}
          t={t}
          theme={theme}
        />
      </div>
    </div>
  );
}

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getAnalStockReal = makeGetAnalStockReal();
  const getAnalBasicInfo = makeGetAnalBasicInfo();

  const mapStateToProps = (state) => {
    return {
      token: getToken(state),
      stockDetail: getAnalStockReal(state),
      analBasicInfo: getAnalBasicInfo(state),
      lang: state.client?.setting?.lang || 'vi',
      algoSignal: state.socket.algoSignal,
      algoStock: state.socket.algoStock,
      algoSChart: state.socket.algoSChart,
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(memo(TabAnalysisStockOverview));
